const TOKEN_STORAGE_KEY = 'accident-platform-token';
const USER_STORAGE_KEY = 'accident-platform-user';

export const getRoleNameList = (profile?: AuthModel.UserProfile) => {
  if (!profile) {
    return [];
  }

  const roleNameList = Array.isArray(profile.roleList)
    ? profile.roleList
        .map((role) => role?.roleName)
        .filter((roleName): roleName is AuthModel.RoleName => Boolean(roleName))
    : [];

  if (roleNameList.length > 0) {
    return Array.from(new Set(roleNameList));
  }

  return profile.roleName ? [profile.roleName] : [];
};

export const getAccessToken = () => {
  return localStorage.getItem(TOKEN_STORAGE_KEY) || '';
};

export const setAccessToken = (token: string) => {
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
};

export const setUserProfile = (profile: AuthModel.UserProfile) => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(profile));
};

export const getUserProfile = () => {
  const rawProfile = localStorage.getItem(USER_STORAGE_KEY);
  if (!rawProfile) {
    return undefined;
  }
  try {
    return JSON.parse(rawProfile) as AuthModel.UserProfile;
  } catch (_error) {
    return undefined;
  }
};

export const clearAuthStorage = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(USER_STORAGE_KEY);
};
